<template>
	<div class="container">
		<nav aria-label="breadcrumb">
			<ol class="breadcrumb">
				<router-link :to="{ name: 'PCReDive'}" tag="li" class="breadcrumb-item">
					<a href="#">首頁</a>
				</router-link>
				<router-link :to="{ name: 'SkillCheck'}" tag="li" class="breadcrumb-item">
					<a href="#">技能查詢</a>
				</router-link>
			</ol>
		</nav>
		<div class="modal fade" id="AddCharacter" tabindex="-1" role="dialog" aria-labelledby="AddCharacterTitle" aria-hidden="true">
			<div class="modal-dialog modal-lg modal-dialog-centered" role="document">
				<div class="modal-content">
					<div class="modal-header">
						<h5 class="modal-title" id="AddCharacterTitle">選擇角色</h5>
						<button type="button" class="close" data-dismiss="modal" aria-label="Close">
							<span aria-hidden="true">&times;</span>
						</button>
					</div>
					<div class="modal-body">
						<div class="battleTeam-box item-box">
							<div class="battleTeam-content">
								<h2>選擇的角色</h2>
								<div class="d-flex flex-wrap mb-3 justify-content-center">
									<div class="p-1 armory-box battle-box" v-for="item in teamList" data-toggle="modal" data-target="#SelectCharacter">
										<div class="armory-img-box gacha-item star3">
											<span @click="deleteUnit(item.unit_id,1)" class="delete_icon">&#8211;</span>
											<img class="unit-img" :src="'/static/images/unit/icon_unit_'+ (Number(item.unit_id)+30) +'.png'" alt="">
										</div>
									</div>
								</div>
								<div v-if="this.skillCheckTeam.length < 5">
									<div class="d-flex flex-wrap mb-3 pl-3">
										<div class="p-1 armory-box battle-box" v-for="(item,index) in units" :value="item" v-if="item.select == false">
											<div class="armory-img-box gacha-item star3" @click="joinTeam(item.unit_id,index)">
												<img :src="'/static/images/unit/icon_unit_'+ (Number(item.unit_id)+30) +'.png'" alt="">
											</div>
											<div class="text-center">
											</div>
										</div>
									</div>
								</div>
								<div class="ok-box text-center my-3 py-1">
									<div class="pcbtn mr-3" data-dismiss="modal" aria-label="Close">完成</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="item-box">
			<div class="row mb-3">
				<div class="col-lg-12 col-md-12 col-12 mb-3">
					<div class="row mb-3">
						<div class="col">
							<div class="d-flex flex-nowrap armory-function">
								<button type="button" class="pcbtn" data-toggle="modal" data-target="#AddCharacter">
									編輯角色
								</button>
							</div>
						</div>
					</div>
					<h3 class="item-title">
						選擇的角色
					</h3>
					<div class="item-content">
						<div class="d-flex flex-wrap mb-3 justify-content-center">
							<div class="p-1 armory-box" v-for="item in teamList">
								<div class="armory-img-box gacha-item star3" style="cursor: default">
									<img class="unit-img" :src="'/static/images/unit/icon_unit_'+ (Number(item.unit_id)+30) +'.png'" alt="">
								</div>
							</div>
						</div>
					</div>
					<h3 class="item-title">
						技能循環
					</h3>
					<div class="item-content">
						<div class="">
							<div class="p-1 armory-box" v-for="item in teamList" style="overflow: auto">
								<div>
									<img class="unit-img" :src="'/static/images/unit/icon_unit_'+ (Number(item.unit_id)+30) +'.png'" alt="">
								</div>
								<table class="table table-bordered">
									<tr>
										<td v-for="time in item.timeline">
											{{time.timeSec}}<br>
											{{time.timeMin}}
										</td>
									</tr>
									<tr>
										<td v-for="time in item.timeline">
											{{time.skill}}
										</td>
									</tr>
								</table>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
export default {
	name: 'SkillCheck',
	data() {
		return {
			units: {},
			skillCheckTeam: [],
			skillList: [],
		}
	},
	metaInfo: {
		// if no subcomponents specify a metaInfo.title, this title will be used
		title: '技能查詢',
		// all titles will be injected into this template
		titleTemplate: '%s | 蘭德索爾圖書館 公主連結 Wiki'
	},
	methods: {
		finish: function() {},
		selectCharacter: function(item) {
			this.selectUnit = item;
		},
		changeStar: function(n, unit) {
			unit.rarity = n;
		},
		deleteUnit: function(value) {
			var self = this;
			var nowTeam = _.remove(self.skillCheckTeam, function(o) {
				return o.unit_id != value;
			});
			var reSelect = _.find(self.units, ['unit_id', value]);

			reSelect.select = false;
			_.forEach(nowTeam, function(o) {
				var reSelect = _.find(self.units, ['unit_id', o.unit_id]);
				reSelect.select = true;
			})
			self.skillCheckTeam = nowTeam;
		},
		getSkill: function(unitId) {
			var self = this;
			var unit_id = unitId.toString();

		},
		getPatternImg: function(unitId) {
			var self = this;
			var attackPattern = _.find(self.$store.getters.getUnitAttackPattern, ["unit_id", unitId.toString()]);
			var loopStart = Number(attackPattern.loop_start);
			var loopEnd = Number(attackPattern.loop_end);
			var start = new Array();
			for (var i = 1; i <= loopStart - 1; i++) {
				if (attackPattern['atk_pattern_' + i] == '1001') {
					start.push("ap01");
				} else if (attackPattern['atk_pattern_' + i] == '1002') {
					start.push("ap02");
				} else {
					start.push("attack");
				}
			}
			var loop = new Array();
			for (var j = loopStart; j <= loopEnd; j++) {
				if (attackPattern['atk_pattern_' + j] == '1001') {
					loop.push("ap01");
				} else if (attackPattern['atk_pattern_' + j] == '1002') {
					loop.push("ap02");
				} else {
					loop.push("attack");
				}
			}
			var unit_attack_pattern = {
				"start": start,
				"loop": loop,
			}
			return unit_attack_pattern;
		},
		joinTeam: function(unit_id, index) {
			var self = this;
			var skillCheckTeam = this.skillCheckTeam;
			var thisUnit = _.find(self.$store.getters.getUnitData, ['unit_id', unit_id]);
			var myUnit = new Object;
			myUnit["search_area_width"] = thisUnit.search_area_width;
			myUnit["unit_id"] = thisUnit.unit_id;
			myUnit["normal_atk_cast_time"] = thisUnit.normal_atk_cast_time;
			var unit_Skill = _.find(self.$store.getters.getUnitSkillData, ["unit_id", unit_id]);
			myUnit["unit_skill"] = {
				"union_burst": unit_Skill.union_burst,
				"main_skill_1": unit_Skill.main_skill_1,
				"main_skill_2": unit_Skill.main_skill_2
			};
			_.forEach(myUnit["unit_skill"], function(o, key) {
				let skill = _.find(self.$store.getters.getSkillData, ["skill_id", o]);
				var skillAction = _.filter(_.pick(skill, ['action_1', 'action_2', 'action_3', 'action_4', 'action_5', 'action_6', 'action_7']), function(o) {
					return o != '0';
				});
				var skillActionDetail = new Array();
				_.forEach(skillAction, function(o, key) {
					var skill = _.find(self.$store.getters.getSkillAction, ["action_id", o]);
					skillActionDetail.push(skill);
				})
				myUnit["unit_skill"][key] = skill;
				myUnit["unit_skill"][key]["Detail"] = skillActionDetail;
			});
			self["units"][index].select = true;
			skillCheckTeam.push(myUnit);
			skillCheckTeam = _.orderBy(skillCheckTeam, 'search_area_width', 'desc');
			this.skillCheckTeam = skillCheckTeam;
		},
		getUnitList: function(rarity) {
			var self = this;
			var unit_data = self.$store.getters.getUnitData;
			var actualUnits = self.$store.getters.getCharaIdentity;
			var list = new Array();
			_.forEach(unit_data, function(value) {
				_.forEach(actualUnits, function(o) {
					if (o.unit_id == _.toInteger(value.unit_id)) {
						o.select = false
						o.search_area_width = value.search_area_width;
						list.push(o);
					}
				});
			});
			list = _.orderBy(list, ["search_area_width"], ["asc"]);
			this.units = list
		},
		mmss: function(sec) {
			var minutes = Math.floor(sec.toFixed(0) / 60);
			var seconds = sec.toFixed(0) - minutes * 60;

			function str_pad_left(string, pad, length) {
				return (new Array(length + 1).join(pad) + string).slice(-length);
			}
			var finalTime = str_pad_left(minutes, '0', 2) + ':' + str_pad_left(seconds, '0', 2);
			return finalTime;
		}
	},
	created: function() {
		var self = this;


		self.skillCheckTeam = [{ "search_area_width": "245", "unit_id": "105701", "normal_atk_cast_time": "1.965", "unit_skill": { "union_burst": { "action_1": "105700101", "action_2": "0", "action_3": "0", "action_4": "0", "action_5": "0", "action_6": "0", "action_7": "0", "depend_action_1": "0", "depend_action_2": "0", "depend_action_3": "0", "depend_action_4": "0", "depend_action_5": "0", "depend_action_6": "0", "depend_action_7": "0", "description": "對面前的 1 名敵人造成特大幅度的物理傷害。", "icon_type": "1001", "name": "暴風雨之劍", "skill_area_width": "0", "skill_cast_time": "0.0", "skill_id": "1057001", "skill_type": "1", "Detail": [{ "action_detail_1": "1", "action_detail_2": "0", "action_detail_3": "0", "action_id": "105700101", "action_type": "1", "action_value_1": "60.0", "action_value_2": "60.0", "action_value_3": "4.8", "action_value_4": "0.0", "action_value_5": "0.0", "action_value_6": "0.0", "action_value_7": "0.0", "class_id": "1", "description": "對敵方單體造成{0}的物理傷害", "level_up_disp": "物理傷害+{0}", "target_area": "1", "target_assignment": "1", "target_count": "1", "target_number": "0", "target_range": "-1", "target_type": "3" }] }, "main_skill_1": { "action_1": "105700201", "action_2": "0", "action_3": "0", "action_4": "0", "action_5": "0", "action_6": "0", "action_7": "0", "depend_action_1": "0", "depend_action_2": "0", "depend_action_3": "0", "depend_action_4": "0", "depend_action_5": "0", "depend_action_6": "0", "depend_action_7": "0", "description": "對面前的 1 名敵人造成中幅度的物理傷害。", "icon_type": "2001", "name": "廣域之劍", "skill_area_width": "0", "skill_cast_time": "1.125", "skill_id": "1057002", "skill_type": "1", "Detail": [{ "action_detail_1": "1", "action_detail_2": "0", "action_detail_3": "0", "action_id": "105700201", "action_type": "1", "action_value_1": "20.0", "action_value_2": "20.0", "action_value_3": "1.6", "action_value_4": "0.0", "action_value_5": "0.0", "action_value_6": "0.0", "action_value_7": "0.0", "class_id": "1", "description": "對敵方單體造成{0}的物理傷害", "level_up_disp": "物理傷害+{0}", "target_area": "1", "target_assignment": "1", "target_count": "1", "target_number": "0", "target_range": "-1", "target_type": "3" }] }, "main_skill_2": { "action_1": "105700301", "action_2": "0", "action_3": "0", "action_4": "0", "action_5": "0", "action_6": "0", "action_7": "0", "depend_action_1": "0", "depend_action_2": "0", "depend_action_3": "0", "depend_action_4": "0", "depend_action_5": "0", "depend_action_6": "0", "depend_action_7": "0", "description": "中幅度恢復自己的 TP。", "icon_type": "2006", "name": "武器破裂", "skill_area_width": "0", "skill_cast_time": "1.125", "skill_id": "1057003", "skill_type": "1", "Detail": [{ "action_detail_1": "1", "action_detail_2": "0", "action_detail_3": "0", "action_id": "105700301", "action_type": "16", "action_value_1": "150.0", "action_value_2": "1.5", "action_value_3": "0.0", "action_value_4": "0.0", "action_value_5": "0.0", "action_value_6": "0.0", "action_value_7": "0.0", "class_id": "1", "description": "回復自身{0}的TP", "level_up_disp": "TP回復量+{0}", "target_area": "1", "target_assignment": "2", "target_count": "1", "target_number": "0", "target_range": "0", "target_type": "7" }] } }, "unit_attack_pattern": { "start": ["ap01", "ap02"], "loop": ["attack", "attack", "ap01", "attack", "ap02"] } }];
	},
	computed: {
		teamList: function() {
			var self = this;
			_.forEach(self.skillCheckTeam, function(o) {
				var unit_attack_pattern = self.getPatternImg(o.unit_id);

				var timeline = []
				console.log(Number(o.normal_atk_cast_time));
				let ap1 = Number(o.unit_skill.main_skill_1.skill_cast_time);
				console.log(ap1);
				let ap2 = Number(o.unit_skill.main_skill_2.skill_cast_time);
				console.log(ap2);
				var nowTime = 0;
				_.forEach(unit_attack_pattern.start, function(j, index) {
					let attackTime = Number(o.normal_atk_cast_time);
					if (j == 'ap01') {
						attackTime = attackTime + ap1;
					} else if (j == 'ap02') {
						attackTime = attackTime + ap1;
					}
					if (index == 0 && j == 'ap01') {
						attackTime = ap1;
					} else if (index == 0 && j == 'ap02') {
						attackTime = ap2;
					}
					nowTime += (attackTime);
					var castTime = 85 - nowTime;
					console.log("85-" + nowTime +"="+ castTime);
					var toMin = self.mmss(castTime);
					var obj = {
						"timeSec": castTime.toFixed(2),
						"timeMin": toMin,
						"skill": j
					}
					timeline.push(obj);
				})
				while (nowTime <= 85) {
					_.forEach(unit_attack_pattern.loop, function(j, index) {
						let attackTime = Number(o.normal_atk_cast_time);
						if (j == 'ap01') {
							attackTime = attackTime + ap1;
						} else if (j == 'ap02') {
							attackTime = attackTime + ap1;
						}
						nowTime += (attackTime);
						var castTime = 85 - nowTime;
						var toMin = self.mmss(castTime);
						console.log("85-" + nowTime +"="+ castTime);
						if (nowTime <= 85 && nowTime > 0) {
							var obj = {
								"timeSec": castTime.toFixed(2),
								"timeMin": toMin,
								"skill": j
							}
							timeline.push(obj);
						}
					})
				}
				o["timeline"] = timeline;

			});

			return self.skillCheckTeam;
		},
	},
	mounted: function() {
		var self = this;
		self.getUnitList();
	}
}

</script>
